import { filter } from "rxjs";
import { isActionOf } from "typesafe-actions";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { BaseEpicsBuilder } from "../epicsBuilder.js";
import "../actions.js";
import { getMessageActions } from "./actions.js";
class MessageEpicsBuilder extends BaseEpicsBuilder {
  _messageLocalizer;
  _messageActions;
  constructor(messageLocalizer) {
    super();
    this._messageLocalizer = messageLocalizer;
    this._messageActions = getMessageActions();
  }
  buildEpicList() {
    return [this.buildShowCodeMessageEpic()];
  }
  buildShowCodeMessageEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(this._messageActions.showCodeMessage)),
      map((action) => {
        const { code, values, mode } = action.payload;
        const messageDescriptor = this._messageLocalizer.getMessageDescriptor(code);
        return this._messageActions.saveMessage({
          message: messageDescriptor,
          values,
          mode
        });
      })
    );
  }
}
export {
  MessageEpicsBuilder
};
//# sourceMappingURL=epics.js.map
